module.exports = __webpack_public_path__ + "fewww/img/banner@2x.b3c200bd.png";